export default class ContractNotBilledFilter {
  externalId: number | null

  resultCenterId: string

  beneficiaryId: string

  customerId: string

  contractNumber: String

  customerDocument: String

  competence: string

  selectedCustomerOption: string = 'name';

  selectedBeneficiaryOption: string = 'name';

  constructor(obj: any = {}) {
    this.externalId = obj.externalId || null
    this.resultCenterId = obj.resultCenterId || ''
    this.beneficiaryId = obj.beneficiaryId || ''
    this.customerId = obj.customerId || ''
    this.contractNumber = obj.contractNumber || ''
    this.customerDocument = obj.customerDocument || ''
    this.competence = obj.competence || ''
  }

  get isTradingNameFetch(): boolean {
    return this.selectedCustomerOption === 'tradingName'
  }

  get isBeneficiaryTradingNameFetch(): boolean {
    return this.selectedBeneficiaryOption === 'tradingName'
  }

  clear() {
    this.externalId = null
    this.resultCenterId = ''
    this.beneficiaryId = ''
    this.customerId = ''
    this.contractNumber = ''
    this.customerDocument = ''
    this.competence = ''
  }
}
